(() => {
  const init = (section) => {
    if (!section || section.dataset.drvCuratedFiltersReady === 'true') return;

    const items = Array.from(section.querySelectorAll('[data-drv-filter-item]'));
    const filterPanels = Array.from(section.querySelectorAll('[data-drv-curated-filters]'));
    const emptyState = section.querySelector('[data-drv-filter-empty]');

    if (!items.length || !filterPanels.length) return;

    section.dataset.drvCuratedFiltersReady = 'true';

    const getSelected = (filterName) => {
      const source = filterPanels[0];
      return Array.from(source.querySelectorAll(`[data-drv-filter="${filterName}"]:checked`)).map((input) => input.value);
    };

    const syncInput = (changedInput) => {
      filterPanels.forEach((panel) => {
        panel.querySelectorAll(`[data-drv-filter="${changedInput.dataset.drvFilter}"]`).forEach((input) => {
          if (input.value === changedInput.value) input.checked = changedInput.checked;
          if (changedInput.type === 'radio' && input.value !== changedInput.value) input.checked = false;
        });
      });
    };

    const apply = () => {
      const selectedModels = getSelected('model');
      const selectedColors = getSelected('color');
      const selectedBatteries = getSelected('battery');
      const selectedPrice = getSelected('price')[0] || 'all';
      let visibleCount = 0;

      items.forEach((item) => {
        const colors = (item.dataset.drvColors || '').split('|').filter(Boolean);
        const batteries = (item.dataset.drvBatteries || '').split('|').filter(Boolean);
        const price = Number(item.dataset.drvPriceMin || 0) / 100;

        const modelMatch = !selectedModels.length || selectedModels.includes(item.dataset.drvModel);
        const colorMatch = !selectedColors.length || selectedColors.some((value) => colors.includes(value));
        const batteryMatch = !selectedBatteries.length || selectedBatteries.some((value) => batteries.includes(value));
        const priceMatch =
          selectedPrice === 'all' ||
          (selectedPrice === 'under-1000' && price < 1000) ||
          (selectedPrice === '1000-1199' && price >= 1000 && price < 1200) ||
          (selectedPrice === '1200-plus' && price >= 1200);
        const visible = modelMatch && colorMatch && batteryMatch && priceMatch;

        item.hidden = !visible;
        item.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (visible) visibleCount += 1;
      });

      section.querySelectorAll('[data-drv-filter-count]').forEach((output) => {
        output.textContent = `${visibleCount} ${visibleCount === 1 ? 'model' : 'models'}`;
      });
      if (emptyState) emptyState.hidden = visibleCount !== 0;
    };

    filterPanels.forEach((panel) => {
      panel.addEventListener('change', (event) => {
        const input = event.target.closest('[data-drv-filter]');
        if (!input) return;
        syncInput(input);
        apply();
      });

      panel.querySelector('[data-drv-filter-clear]')?.addEventListener('click', () => {
        filterPanels.forEach((currentPanel) => {
          currentPanel.querySelectorAll('input[type="checkbox"]').forEach((input) => {
            input.checked = false;
          });
          currentPanel.querySelectorAll('[data-drv-filter="price"]').forEach((input) => {
            input.checked = input.value === 'all';
          });
        });
        apply();
      });
    });

    apply();
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-drv-curated-collection]').forEach(init);
  };

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
